export const API_URL = process.env.REACT_APP_API_URL;
export const GOOGLE_CLIENT_ID =
	"544842269088-rn8spcpkn2av300od67g5eim7vtagncb.apps.googleusercontent.com";

export const DND_LINK = process.env.REACT_APP_DND_LINK;
export const WEBAPP_URL = process.env.REACT_APP_WEBAPP_URL;
export const UNIVERSAL_SEARCH_URL = process.env.REACT_APP_UNIVERSAL_SEARCH_URL;
export const DEPRENEUR_PROFILE_ENHANCEMENT_LINK = process.env.REACT_APP_DEPRENEUR_PROFILE_ENHANCEMENT_LINK;
export const MARKETING_TOOL_ENTRIES_LINK = process.env.REACT_APP_MARKETING_TOOL_ENTRIES_LINK;
export const DOWNLOAD_API_URL = process.env.REACT_APP_DOWNLOAD_API_URL;
export const DOWNLOAD_UMC_CUSTOMER_FEEDBACK = process.env.REACT_APP_DOWNLOAD_SP_UMC_CUSTOMER_FEEDBACK;